/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';
import { ListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import styles from './Content.module.css';

export const ContentCountryRoom = () => {
  const { locale } = useIntl();
  const searchCategories = [ListingsSearchCategory.Room];

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Rooms for rent in Netherlands
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Are you in search of a room for rent in Netherlands? Look no
            further! Kamernet offers a wide range of options for individuals
            seeking affordable and convenient living options. Whether you're a
            student, a young professional, or anyone looking for a comfortable
            place to call home, we have the perfect room for you.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Why choose a room for rent in Netherlands?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Renting a room is an excellent option for those seeking
            budget-friendly accommodation without compromising on quality.
            Whether you are looking for a room in a shared apartment or a
            student room in a student house, you'll find a variety of options to
            choose from in cities and towns across the Netherlands.`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Finding a room in Netherlands can be difficult. With Kamernet, you
            can easily connect with potential roommates and landlords to find a
            place that matches your budget and preferences. Don't miss out on
            the opportunity! Signup now and find your perfect room for rent in
            Netherlands today.`}
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Useful Links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.en,
        )}
      >
        Almere rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.en,
        )}
      >
        Nijmegen rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.en,
        )}
      >
        Hilversum rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.en,
        )}
      >
        Eindhoven rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.en,
        )}
      >
        Hoofddorp rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.en,
        )}
      >
        Zaandam rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.en,
        )}
      >
        Arnhem rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.en,
        )}
      >
        Tilburg rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.en,
        )}
      >
        Enschede rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.en,
        )}
      >
        Amersfoort rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.en,
        )}
      >
        Zeist rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.en,
        )}
      >
        Breda rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.en,
        )}
      >
        Maastricht rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.en,
        )}
      >
        Nieuwegein rooms
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.en,
        )}
      >
        Schiedam rooms
      </NavLink.Anchor>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        Kamers te huur in Nederland
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Ben je op zoek naar een kamer te huur in Nederland? Zoek dan niet
        verder! Kamernet biedt een breed aanbod aan huurders die op zoek zijn
        naar een betaalbare en geschikte kamer. Of je nu een student bent, een
        young professional, of iemand die op zoek is naar een comfortabele plek
        om zich thuis te voelen, wij hebben de ideale kamers te huur voor jou.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Waarom kiezen we voor een kamer te huur in Nederland?
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Een kamer huren is een uitstekende optie voor wie op zoek is naar een
        huurhuis zonder in te leveren op kwaliteit. Of je nu op zoek bent naar
        een eenpersoonskamer in een gedeeld appartement of een kamer in een
        studentenhuis, je kunt kiezen uit verschillende opties in steden en
        dorpen door heel Nederland.
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        Een kamer vinden in Nederland kan moeilijk zijn. Met Kamernet kun je
        gemakkelijk in contact komen met potentiële huisgenoten en verhuurders
        om een kamer te vinden die past bij je budget en voorkeuren. Mis deze
        kans niet! Schrijf je nu in en vind vandaag nog je ideale kamer te huur
        in Nederland.
      </Typography>
      <Typography variant="h3" className={styles.title}>
        Handige links:
      </Typography>
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'almere', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Almere
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nijmegen', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Nijmegen
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hilversum', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Hilversum
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'eindhoven', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Eindhoven
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'hoofddorp', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Hoofddorp
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zaandam', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Zaandam
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'arnhem', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Arnhem
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'tilburg', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Tilburg
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'enschede', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Enschede
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'amersfoort', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Amersfoort
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'zeist', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Zeist
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'breda', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Breda
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'maastricht', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Maastricht
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'nieuwegein', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Nieuwegein
      </NavLink.Anchor>
      |
      <NavLink.Anchor
        href={ROUTES.ListingsSearchCity.getURL(
          { city: 'schiedam', searchCategories },
          Locale.nl,
        )}
      >
        Kamer Schiedam
      </NavLink.Anchor>
    </React.Fragment>
  );
};
